// DUPLICATED from town-square/src/hooks/useReferralSettings.ts — edit both or neither. The client
// cannot import from the town-square workspace, so the invite modal (also duplicated) reads its own
// copy of this hook. The GraphQL doc, enum normalization, and fallbacks must stay identical.

import { gql, useQuery } from '@apollo/client';
import {
  mechanismGrantsPoints,
  mechanismGrantsSubscription,
  REFERRAL_POINTS,
  ReferralMechanism,
} from '@arthelper/shared/referral';

const REFERRAL_SETTINGS = gql`
  query ReferralSettings {
    referralSettings {
      activeMechanism
      referralPoints
      giftTermMonths
    }
  }
`;

export interface ReferralSettingsState {
  activeMechanism: ReferralMechanism;
  referralPoints: number;
  giftTermMonths: number;
  grantsPoints: boolean;
  grantsSubscription: boolean;
  loading: boolean;
}

/** The live referral mechanism, for driving invite copy. Falls back to the seed defaults. */
export function useReferralSettings(): ReferralSettingsState {
  const { data, loading } = useQuery<{
    referralSettings: { activeMechanism: ReferralMechanism; referralPoints: number; giftTermMonths: number };
  }>(REFERRAL_SETTINGS);

  const settings = data?.referralSettings;
  // GraphQL serializes the enum UPPERCASE (POINTS); the shared mechanism helpers key on the
  // lowercase internal value, so normalize here.
  const activeMechanism =
    (String(settings?.activeMechanism ?? 'points').toLowerCase() as ReferralMechanism) ?? 'points';

  return {
    activeMechanism,
    referralPoints: settings?.referralPoints ?? REFERRAL_POINTS,
    giftTermMonths: settings?.giftTermMonths ?? 1,
    grantsPoints: mechanismGrantsPoints(activeMechanism),
    grantsSubscription: mechanismGrantsSubscription(activeMechanism),
    loading,
  };
}
